import {Behavior, BehaviorsRequest, BehaviorsResultsMap} from 'app_api/projects/behaviors/types';
import {behaviorsClient, createBehavior, updateBehavior} from 'common/report/queries/app-api/behaviors';
import {ApiResource} from 'common/util/model-resource/api-resource';

const CREATE_KEY = `create`;

export class BehaviorsResource extends ApiResource<Behavior> {
  apiClient = behaviorsClient;

  private async requestWrapper(loadingKey: string, callback: () => Promise<BehaviorsResultsMap>) {
    this.fetchesInProgress.set(loadingKey, undefined);
    this.notifySubscribers();
    try {
      const results = await callback();

      this.update(results, {partialUpdate: false});

      return results;
    } finally {
      this.fetchesInProgress.delete(loadingKey);
      this.notifySubscribers();
    }
  }

  patch(id: number, behavior: Partial<Behavior>): Promise<BehaviorsResultsMap> {
    const behaviorId = id.toString();
    return this.requestWrapper(behaviorId, () => updateBehavior({behaviorId, behavior}));
  }

  create(behavior: BehaviorsRequest): Promise<BehaviorsResultsMap> {
    return this.requestWrapper(CREATE_KEY, () => createBehavior(behavior));
  }

  isLoading(id?: number) {
    if (id) {
      return this.fetchesInProgress.has(id.toString());
    }
    return this.fetchesInProgress.has(CREATE_KEY);
  }
}
